import React from "react";

const TextInfo = ({ title, text, className }) => {
  return (
    <div>
      <h3 className={`font-bold text-[#052e16] ${className}`}>{title}</h3>
      <div className="text-[#878787] mb-3 whitespace-pre-line">{text}</div>
    </div>
  );
};

export default TextInfo;
